export default {
    props: {
        animationCloseEffects: {
            type: String,
            default: undefined,
            kComposite: 'animation.close.effects'
        }, 
        animationCloseDuration: {
            type: Number,
            default: undefined,
            kComposite: 'animation.close.duration'
        }, 
        animationOpenEffects: {
            type: String,
            default: undefined,
            kComposite: 'animation.open.effects'
        }, 
        animationOpenDuration: {
            type: Number,
            default: undefined,
            kComposite: 'animation.open.duration'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/Common/Animation.js